module.exports = __webpack_public_path__ + "img/3.ad9a8f69.jpg";